export default defineNuxtRouteMiddleware((to, from) => {
  const localePath = useLocalePath();
  if (to.query.redirect) {
    const userStore = useUserStore();
    userStore.isLoggedIn
      ? navigateTo(localePath(to.query.redirect.toString()))
      : navigateTo(localePath(`/loading?auth=true&redirect=${to.fullPath}`));
  }
});
